{
  "nav": {
    "home": "コミュニティホーム",
    "articles": "ニュース・記事",
    "events": "カードイベント",
    "dealers": "取扱店ディレクトリ"
  },
  "layout": {
    "breadcrumbHome": "ホーム",
    "breadcrumbCommunity": "コミュニティ",
    "eyebrow": "コミュニティハブ",
    "title": "ニュース・イベント・英国取扱店",
    "subtitle": "英国のトレーディングカード業界のあらゆる最新情報を、BidNovaが厳選してお届けします。"
  },
  "home": {
    "tiles": {
      "articlesTitle": "ニュース・記事",
      "articlesDesc": "市場動向と購入ガイド",
      "eventsTitle": "英国カードイベント",
      "eventsDesc": "開催予定のイベント・大会",
      "dealersTitle": "取扱店ディレクトリ",
      "dealersDesc": "信頼できる英国のカードショップ",
      "explore": "見てみる"
    },
    "articlesEyebrow": "市場動向、購入ガイド、コミュニティの声",
    "articlesTitle": "最新ニュース・ガイド",
    "eventsEyebrow": "トレードナイト、大会、鑑定持ち込みイベント",
    "eventsTitle": "開催予定の英国カードイベント",
    "dealersEyebrow": "信頼できる英国のカードショップ・ホビーショップ・通販店",
    "dealersTitle": "注目の取扱店",
    "viewAll": "すべて見る →",
    "readMore": "続きを読む",
    "emptyArticles": "記事は近日公開予定です。",
    "emptyEvents": "現在開催予定のイベントはありません。しばらくお待ちください。",
    "emptyDealers": "取扱店ディレクトリは近日公開予定です。"
  },
  "articles": {
    "index": {
      "title": "ニュース・記事",
      "subtitle": "英国のカードコミュニティによる市場動向、購入ガイド、ストーリー。",
      "searchPlaceholder": "記事を検索…",
      "searchLabel": "記事を検索",
      "all": "すべて",
      "empty": "条件に一致する記事が見つかりませんでした。",
      "readMore": "続きを読む",
      "authorFallback": "BidNova"
    },
    "detail": {
      "authorFallback": "BidNovaチーム",
      "backLink": "記事一覧に戻る"
    }
  },
  "events": {
    "communityIndex": {
      "title": "英国カードイベントカレンダー",
      "subtitle": "英国各地で開催されるカードショー、大会、トレードナイト、鑑定持ち込みイベント、コレクター交流会。",
      "empty": "現在開催予定のイベントはありません。しばらくお待ちください。"
    },
    "publicIndex": {
      "eyebrow": "コミュニティ",
      "title": "開催予定のカードイベント",
      "subtitle": "英国各地で開催されるカードショー、大会、トレードナイト、鑑定持ち込みイベント、コレクター交流会。",
      "empty": "現在開催予定のイベントはありません。しばらくお待ちください。"
    },
    "card": {
      "featured": "注目",
      "viewDetails": "詳細を見る"
    },
    "detail": {
      "recurring": "定期開催",
      "days": "日",
      "hours": "時間",
      "minutes": "分",
      "when": "開催日時",
      "where": "会場",
      "openInMaps": "地図で見る",
      "rsvp": "参加登録",
      "getTickets": "チケットを購入",
      "visitWebsite": "ウェブサイトを見る",
      "organisedBy": "主催：{name}"
    },
    "section": {
      "eyebrow": "コミュニティ",
      "title": "開催予定の英国カードイベント",
      "viewAll": "すべてのイベントを見る →"
    }
  },
  "dealers": {
    "index": {
      "title": "取扱店ディレクトリ",
      "subtitle": "信頼できる英国のカードショップ、ホビーショップ、鑑定サービス、通販店。",
      "searchPlaceholder": "店名・地域・郵便番号で検索…",
      "searchLabel": "取扱店を検索",
      "typeLabel": "種別",
      "gameLabel": "対応カード",
      "all": "すべて",
      "empty": "条件に一致する取扱店が見つかりませんでした。",
      "featured": "注目",
      "visitWebsite": "ウェブサイトを見る"
    },
    "detail": {
      "featured": "注目",
      "contact": "お問い合わせ",
      "website": "ウェブサイト",
      "openingHours": "営業時間",
      "backLink": "ディレクトリに戻る"
    }
  },
  "updates": {
    "eyebrow": "コミュニティ",
    "title": "最新のコミュニティ情報",
    "featured": "注目",
    "readMore": "続きを読む",
    "communityUpdateAlt": "BidNova コミュニティアップデート"
  },
  "partners": {
    "index": {
      "eyebrow": "パートナーディレクトリ",
      "title": "信頼できるBidNovaパートナー",
      "subtitle": "以下のパートナーはすべてBidNovaチームが審査・承認済みです。カードショップや鑑定会社から、配送・保険の専門企業まで幅広く掲載しています。",
      "becomePartner": "パートナーになる →",
      "searchPlaceholder": "名前・説明・地域でパートナーを検索…",
      "searchLabel": "パートナーを検索",
      "verifiedOnly": "認証済みのみ表示",
      "resultsCount": "{count, plural, other {該当件数：#件}}",
      "all": "すべて",
      "loading": "パートナーを読み込み中…",
      "empty": "条件に一致するパートナーが見つかりませんでした。"
    },
    "detail": {
      "loading": "読み込み中…",
      "unavailable": "このパートナー情報は現在ご利用いただけません。",
      "notFound": "パートナーが見つかりませんでした。",
      "website": "ウェブサイト",
      "partnerSince": "パートナー登録年：{year}",
      "contact": "お問い合わせ",
      "active": "出品中",
      "sold": "落札済み",
      "since": "登録年",
      "about": "詳細",
      "shipping": "配送について",
      "policies": "ポリシー",
      "bidnovaShop": "BidNovaショップ",
      "alsoSells": "このパートナーはBidNova上でも販売しています。",
      "visitShop": "ショップを見る",
      "social": "ソーシャルメディア"
    },
    "apply": {
      "eyebrow": "パートナーになる",
      "title": "BidNovaとともにビジネスを成長させる",
      "subtitle": "公式パートナー、注目ショップ、鑑定会社、アクセサリーブランドなど、BidNovaのエコシステムへの参加をお申し込みください。すべての掲載枠は現在無料で、チームが厳選のうえ掲載します。"
    }
  },
  "shops": {
    "index": {
      "eyebrow": "注目ショップ",
      "title": "信頼できるBidNova出品者",
      "subtitle": "以下のショップはすべてBidNovaチームが審査・承認済みです。",
      "directoryTitle": "すべての注目ショップ",
      "directoryEyebrow": "ディレクトリ"
    },
    "detail": {
      "unavailable": "このショップは現在ご利用いただけません。",
      "notFound": "ショップが見つかりませんでした。",
      "fullProfile": "プロフィールを見る",
      "liveAuctions": "開催中のオークション",
      "noAuctions": "現在このショップに開催中のオークションはありません。",
      "sales": "{count, plural, other {販売実績：#件}}"
    }
  },
  "advertise": {
    "eyebrow": "パートナープログラム",
    "title": "BidNovaで広告を掲載",
    "subtitlePrefix": "英国で最も熱量の高いトレーディングカードコミュニティにアプローチできます。ローンチ期間中は、すべての広告枠を",
    "subtitleHighlight": "無料",
    "subtitleSuffix": "でご利用いただけ、BidNovaチームが厳選のうえ掲載します。",
    "freeBadge": "ローンチ期間中は無料・クレジットカード不要",
    "mostPopular": "人気No.1",
    "applyNow": "今すぐ申し込む",
    "disclaimer": "掲載枠はすべて弊社チームが手動で審査し、「Sponsored」と明確に表示されます。BidNovaは特定の閲覧数・クリック数・販売実績を保証するものではありません。",
    "faqTitle": "よくあるご質問",
    "ctaTitle": "直接ご相談されたい方へ",
    "ctaSubtitle": "貴社のビジネスについてお聞かせください。ご要望に合わせたプランをご提案します。",
    "ctaButton": "申し込みを開始",
    "placements": {
      "banner": {
        "name": "ホームページ・スポンサーバナー",
        "tagline": "すべての訪問者の目に触れるプレミアムなヒーロー枠。",
        "b1": "ホームページの最上部に表示",
        "b2": "「Sponsored」と明確に表示",
        "b3": "透明性のあるインプレッション・クリック数レポート",
        "b4": "厳選された少数のパートナーとローテーション表示"
      },
      "featuredShop": {
        "name": "注目ショップ",
        "tagline": "本気のコレクターにショップをアピール。",
        "b1": "ホームページの注目ショップグリッドに表示",
        "b2": "BidNova出品者プロフィールへの直接リンク",
        "b3": "公開プロフィールに認証バッジを表示",
        "b4": "カテゴリページで優先表示"
      },
      "officialPartner": {
        "name": "公式パートナー",
        "tagline": "BidNova公式パートナーネットワークに参加。",
        "b1": "公式パートナーカルーセルにロゴを掲載",
        "b2": "専用の公開パートナープロフィールページ",
        "b3": "ニュースレター・SNSでの相互プロモーション",
        "b4": "BidNovaとの長期的なブランド連携"
      },
      "eventSponsorship": {
        "name": "イベント・カスタムスポンサーシップ",
        "tagline": "オーダーメイドのキャンペーンとイベント連携。",
        "b1": "大会・イベント・賞品スポンサーシップ",
        "b2": "カスタムホームページジャック",
        "b3": "編集タイアップ企画",
        "b4": "貴社のブランド・ターゲットに合わせて調整"
      }
    },
    "faqs": {
      "q1": {
        "q": "費用はいくらですか？",
        "a": "パートナーネットワーク拡大中の現在、BidNovaの広告枠はすべて無料でご利用いただけます。今後変更がある場合は、事前に十分な余裕をもってご案内します。"
      },
      "q2": {
        "q": "広告はどこに表示されますか？",
        "a": "ホームページのスポンサー枠、注目ショップグリッド、公式パートナーカルーセル、または弊社チームと合意したオーダーメイドのキャンペーンに表示できます。"
      },
      "q3": {
        "q": "インプレッションとクリックはどのように計測されますか？",
        "a": "インプレッションは掲載枠が実際に画面に表示された場合のみカウントされ、クリックはサーバー側で重複防止の仕組みとともに記録されます。個人を特定する情報は保存されません。"
      },
      "q4": {
        "q": "オーダーメイドのスポンサーシップは可能ですか？",
        "a": "はい。イベントスポンサーシップ、カスタムホームページジャック、統合キャンペーンなどご用意しています。お申し込みフォームにアイデアをご記入ください。"
      }
    },
    "apply": {
      "eyebrow": "BidNovaで広告を掲載",
      "title": "英国トップクラスのカード市場をスポンサー",
      "subtitle": "貴社のビジネスと、BidNovaのコレクターコミュニティへのアプローチ方法についてお聞かせください。掲載枠は弊社チームが厳選いたします。クレジットカードは不要です。"
    }
  },
  "featuredShops": {
    "eyebrow": "厳選出品者",
    "title": "注目ショップ",
    "browseAll": "すべてのショップを見る →",
    "live": "出品中",
    "sold": "販売実績",
    "rating": "評価",
    "newSeller": "新規出品者",
    "new": "新規",
    "sales": "販売実績",
    "visitShop": "ショップを見る",
    "viewShop": "ショップを見る",
    "noneInCategory": "このカテゴリーにはまだショップがありません。",
    "all": "すべて",
    "verifiedAlt": "認証済み出品者",
    "sellerFallback": "BidNova 出品者"
  },
  "partnerCarousel": {
    "eyebrow": "業界から信頼される",
    "title": "信頼できるパートナー",
    "verifiedAlt": "認証済み",
    "officialPartnerSuffix": "（公式パートナー）"
  },
  "becomePartnerCta": {
    "eyebrow": "パートナーネットワーク",
    "headlineDefault": "BidNova Auctionsとともにビジネスを成長させる",
    "descriptionDefault": "貴社のビジネスを宣伝し、注目ショップになる、またはBidNova公式パートナーネットワークに参加しましょう。",
    "becomePartner": "パートナーになる",
    "advertiseWithUs": "広告を掲載する",
    "closed": "現在お申し込みを一時停止しています。またのご案内をお待ちください。"
  },
  "newsletter": {
    "eyebrow": "ニュースレター",
    "title": "BidNovaコミュニティに参加",
    "subtitle": "新着オークション、注目カード、パートナー特典、カードイベント、マーケット情報をお届けします。",
    "emailPlaceholder": "you@example.com",
    "emailLabel": "メールアドレス",
    "subscribe": "登録する",
    "subscribing": "登録中…",
    "consentLabel": "BidNovaからのメール受信に同意します",
    "consentPrefix": "BidNova Auctionsからのマーケティングメール受信に同意します。いつでも配信を停止できます。詳細は",
    "privacyLink": "プライバシーポリシー",
    "consentError": "続けるには同意チェックボックスを選択してください。",
    "genericError": "エラーが発生しました。もう一度お試しください。",
    "successTitle": "登録が完了しました",
    "successBody": "BidNovaのオークション情報やコミュニティニュースをメールでお届けします。"
  },
  "partnerForm": {
    "types": {
      "featuredShop": "注目ショップ",
      "officialPartner": "公式パートナー",
      "homepageAdvertising": "ホームページスポンサー",
      "eventSponsor": "イベントパートナー",
      "gradingCompany": "鑑定会社",
      "accessoriesStore": "アクセサリーストア",
      "custom": "その他"
    },
    "consentRequired": "続けるには利用規約に同意してください。",
    "genericError": "エラーが発生しました",
    "successTitle": "お申し込みを受け付けました",
    "successBody": "BidNova Auctionsとのパートナーシップにご関心をお寄せいただきありがとうございます。弊社チームが内容を確認のうえ、メールにてご連絡いたします。",
    "backToHome": "ホームに戻る",
    "applicationsClosed": "現在お申し込みを一時停止しています。フォームへの入力は可能ですが、再開まで送信は保留されます。",
    "sectionBusiness": "事業情報",
    "sectionSocial": "ソーシャルメディア",
    "sectionApplication": "お申し込み内容",
    "sectionBrief": "広告ブリーフ",
    "fields": {
      "businessName": "事業者名 *",
      "contactName": "担当者名 *",
      "businessEmail": "事業用メールアドレス *",
      "contactPhone": "電話番号",
      "website": "ウェブサイト",
      "businessType": "事業種別 *",
      "country": "国",
      "instagram": "Instagram",
      "facebook": "Facebook",
      "discord": "Discord",
      "applicationType": "申し込み種別 *",
      "existingSeller": "既存のBidNova出品者ユーザー名（任意）",
      "logoUrl": "ロゴ画像URL",
      "bannerUrl": "バナー画像URL（任意）",
      "requestedPlacement": "希望の掲載枠",
      "noPreference": "指定なし",
      "estimatedBudget": "想定予算（£）",
      "requestedStart": "希望開始日",
      "requestedEnd": "希望終了日",
      "advertisingGoal": "広告の目的",
      "advertisingGoalPlaceholder": "このキャンペーンで達成したいことを教えてください",
      "description": "説明",
      "services": "提供サービス",
      "notes": "備考"
    },
    "consentPrefix": "BidNova Auctionsの",
    "consentMiddle": "および",
    "consentSuffix": "に同意し、本申し込みに関するご連絡を受けることに同意します。",
    "termsLink": "利用規約",
    "privacyLink": "プライバシーポリシー",
    "submit": "申し込みを送信",
    "submitting": "送信中…"
  }
}
